import React from "react";
import { SlidersHorizontal } from "lucide-react";
import Button from "../common/Button";
import Select from "../common/Select";

// Common hour range options for the dropdowns
const HOUR_OPTIONS = [
    { value: "", label: "Any" },
    { value: "500", label: "500 hrs" },
    { value: "1000", label: "1,000 hrs" },
    { value: "1500", label: "1,500 hrs" },
    { value: "2000", label: "2,000 hrs" },
    { value: "3000", label: "3,000 hrs" },
    { value: "5000", label: "5,000 hrs" },
    { value: "7500", label: "7,500 hrs" },
    { value: "10000", label: "10,000 hrs" },
    { value: "15000", label: "15,000 hrs" },
    { value: "20000", label: "20,000+" },
];

const ProfessionalSideFilters = ({
    filters,
    handleFilterChange,
    resetFilters,
    pilotTypes,
    aviationCategoryChoices,
}) => {
    const activeFilterCount = [
        filters.pilot_type ? 1 : 0,
        filters.aircraft_type ? 1 : 0,
        filters.min_hours ? 1 : 0,
        filters.max_hours ? 1 : 0,
        filters.total_hours ? 1 : 0,
        filters.aviation_category ? 1 : 0,
    ].reduce((a, b) => a + b, 0);

    return (
        <aside className="lg:col-span-4 xl:col-span-3">
            <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 sticky top-24 transition-all duration-200 hover:shadow-xl">
                <div className="flex justify-between items-center mb-6">
                    <div className="flex items-center gap-2">
                        <SlidersHorizontal className="w-5 h-5 text-gray-700" />
                        <h3 className="font-bold text-lg text-gray-900">Filters</h3>
                        {activeFilterCount > 0 && (
                            <span className="bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full">
                                {activeFilterCount}
                            </span>
                        )}
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={resetFilters}
                        className="text-gray-500 hover:text-gray-700 h-auto p-0"
                    >
                        Clear All
                    </Button>
                </div>

                <div className="space-y-6">
                    {/* Pilot Type */}
                    {/* <FilterSection title="Pilot Type">
                        <Select
                            onChange={(value) => handleFilterChange("pilot_type", value)}
                            value={filters.pilot_type}
                            options={pilotTypes || []}
                            placeholder="Select Pilot Type"
                        />
                    </FilterSection> */}

                    {/* Aircraft Type */}
                    <FilterSection title="Aircraft Type">
                        <input
                            type="text"
                            placeholder="e.g. B737, A320"
                            value={filters.aircraft_type}
                            onChange={(e) => handleFilterChange("aircraft_type", e.target.value)}
                            className="w-full p-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 outline-none"
                        />
                    </FilterSection>

                    {/* Flight Hours */}
                    <FilterSection title="Flight Hours">
                        <div className="space-y-3">
                            <div>
                                <label className="block text-xs text-gray-500 mb-1">Minimum</label>
                                <Select
                                    onChange={(value) => handleFilterChange("min_hours", value)}
                                    value={filters.min_hours}
                                    options={HOUR_OPTIONS}
                                    placeholder="Min hours"
                                />
                            </div>
                            <div>
                                <label className="block text-xs text-gray-500 mb-1">Maximum</label>
                                <Select
                                    onChange={(value) => handleFilterChange("max_hours", value)}
                                    value={filters.max_hours}
                                    options={HOUR_OPTIONS}
                                    placeholder="Max hours"
                                />
                            </div>
                            <div>
                                <label className="block text-xs text-gray-500 mb-1">Total (exact)</label>
                                <Select
                                    onChange={(value) => handleFilterChange("total_hours", value)}
                                    value={filters.total_hours}
                                    options={HOUR_OPTIONS}
                                    placeholder="Exact total"
                                />
                            </div>
                        </div>
                    </FilterSection>

                    {/* Aviation Category */}
                    <FilterSection title="Aviation Category">
                        <Select
                            onChange={(value) => handleFilterChange("aviation_category", value)}
                            value={filters.aviation_category}
                            options={
                                aviationCategoryChoices
                                    ? [{ value: "", label: "All Categories" }, ...aviationCategoryChoices]
                                    : [{ value: "", label: "All Categories" }]
                            }
                            placeholder="Select Category"
                        />
                    </FilterSection>
                </div>
            </div>
        </aside>
    );
};

const FilterSection = ({ title, children }) => (
    <div className="transition-all duration-200">
        <h4 className="font-semibold mb-3 text-secondary-800 text-sm uppercase tracking-wider">{title}</h4>
        {children}
    </div>
);

export default ProfessionalSideFilters;
